export const name = "UNIX_MICROS";
export const summary = `Converts a \`TIMESTAMP\` value to the number of microseconds since 1970-01-01 00:00:00 UTC.`;
export const reference = `
## UNIX_MICROS

Converts a \`TIMESTAMP\` value to the number of microseconds since 1970-01-01 00:00:00 UTC.

\`\`\`
UNIX_MICROS(timestamp_expression)
\`\`\`

### Description

Returns the number of microseconds since \`1970-01-01 00:00:00 UTC\`.


### Return Data Type

\`INT64\`


### Examples



\`\`\`
SELECT UNIX_MICROS(TIMESTAMP "2008-12-25 15:30:00+00") AS micros;

/*------------------*
 | micros |
 +------------------+
 | 1230219000000000 |
 *------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/timestamp_functions
`;
